import type { ReactNode } from "react";
import { Row } from "react-grid-system";
import type { RowProps } from "react-grid-system";
import styled from "styled-components";
import { theme } from "../../theme";

const StyledRow = styled(Row).attrs({ gutterWidth: 16 })<{
  $isSelected?: boolean;
  $clickable?: boolean;
}>`
  border-bottom: 1px solid ${theme.colors.grey05};
  padding: 12px 8px;
  background-color: ${(props) =>
    props.$isSelected ? theme.colors.selected : "transparent"};

  &:hover {
    background-color: ${(props) =>
      props.$clickable !== false ? theme.colors.hover : "transparent"};
    cursor: ${(props) => (props.$clickable !== false ? "pointer" : "default")};
  }
`;

type TableRowProps = Omit<RowProps, "ref"> & {
  children: ReactNode;
  isSelected?: boolean;
  clickable?: boolean;
};

const TableRow = ({
  children,
  isSelected,
  clickable,
  ...props
}: TableRowProps) => (
  <div style={{ padding: "0 8px" }}>
    <StyledRow $isSelected={isSelected} $clickable={clickable} {...props}>
      {children}
    </StyledRow>
  </div>
);

export default TableRow;
